import { Button, Text, Accordion } from '@cash-me/react-components'
import styled from 'styled-components'

import { Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, space } = theme

export const TutorialWhatsApp = styled.div`
  width: 100%;
  background-color: #fff;
  padding-top: ${space['spacing-xxl']};
  padding-bottom: ${space['spacing-xxl']};

  @media (${media.tablet}) {
    padding-top: ${space['spacing-giga']};
    padding-bottom: ${space['spacing-giga']};
  }
`
export const Infos = styled(GSInfos)`
  text-align: left;
  align-self: center;
  padding-bottom: ${space['spacing-sm']};

  @media (${media.tablet}) {
    text-align: center;
  }
`

export const GroupElements = styled.div`
  display: flex;
  flex-direction: column;
  place-content: center;
`

export const ImageWrapper = styled.div`
  display: none;

  @media (${media.desktop}) {
    display: flex;
    padding-top: ${space['spacing-mega']};
    justify-content: center;
    align-items: center;
  }
`
export const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xl']};

  @media (${media.tablet}) {
    padding-top: ${space['spacing-xs']};
  }

  @media (${media.desktop}) {
    padding: ${space['spacing-mega']} 0;
  }
`
export const ContentStep = styled.div`
  display: flex;
  gap: ${space['spacing-sm']};
  justify-content: flex-start;

  @media (${media.tablet}) {
    gap: ${space['spacing-md']};
  }
`
export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: ${space['spacing-xxs']};

  @media (${media.tablet}) {
    gap: ${space['spacing-sm']};
  }
`
export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 2px solid #ff19af;
  flex: 1 0 50px;
  max-width: 50px;
  max-height: 50px;
`

export const Image = styled.div`
  position: relative;
  width: 526px;
  height: 610px;
`

export const AttentionList = styled.ul`
  padding: ${space['spacing-sm']} 0;
  padding-left: ${space['spacing-lg']};
  list-style-type: disc;

  p {
    line-height: ${space['spacing-lg']};
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`

export const ButtonDS = styled(Button)`
  align-self: center;
  margin-bottom: ${space['spacing-sm']};
  width: 100%;

  @media (${media.tablet}) {
    width: max-content;
    justify-content: space-between;
    gap: ${space['spacing-lg']};
  }
`

export const TextDS = styled(Text)`
  line-height: ${space['spacing-lg']};

  a {
    color: inherit;
    text-decoration: underline;
    overflow-wrap: anywhere;
  }
`

export const AccordionDS = styled(Accordion)`
  background-color: #f3f6ff;
  border: 2px solid #bdceff;
  border-radius: 7px;
  padding: ${space['spacing-md']};
  padding-bottom: ${space['spacing-xs']};

  ul {
    list-style-type: disc;
  }

  @media (${media.tablet}) {
    padding: ${space['spacing-xl']};
    padding-bottom: ${space['spacing-md']};
  }

  @media (${media.desktop}) {
    padding-bottom: ${space['spacing-sm']};
  }
`
